import Collection from "./Collection";
import Item from "./Item";

export { Item as CollectionItem };
export default Collection;
